import { Affix, AffixBaseProps, Group, Paper } from '@mantine/core';
import clsx from 'clsx';
import React from 'react';
import { IconButton } from 'src/components/Buttons';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';

import { Button } from '../Button';
import * as styles from './MobileFloatingActionBar.css';

export interface ActionBarItem {
  id: string;
  content: React.ReactNode;
  onClick: () => void;
  type?: 'icon' | 'button';
  disabled?: boolean;
  className?: string;
}

export type MobileFloatingActionBarProps = AffixBaseProps & {
  actions: ActionBarItem[];
  opacity?: number;
};

export const MobileFloatingActionBar = ({
  actions,
  position = { bottom: vars.spacing.lg, left: '50%' },
  ...rest
}: MobileFloatingActionBarProps) => {
  const { isDarkMode } = useSiteTheme();
  return (
    // TODO - current this component only good for centering bottom,
    // we need to make this component position by enum values
    // TopLeft, TopCenter, TopRight, BottomLeft, BottomCenter, BottomRight, Center
    <Affix
      {...rest}
      position={position}
      style={{ transform: 'translateX(-50%)' }}
    >
      <Paper
        radius={vars.borderRadius.m}
        p={vars.spacing.xs}
        bg={
          isDarkMode
            ? vars.color.backgroundSecondary
            : vars.color.backgroundPrimary
        }
        className={clsx(styles.glowContainer, {
          [styles.glowContainerDark]: isDarkMode,
        })}
      >
        <Group
          gap={vars.spacing.sm}
          align="center"
          justify="center"
          wrap="nowrap"
        >
          {actions.map((action) => {
            if (action.type === 'button') {
              return (
                <Button
                  key={action.id}
                  shape="rect"
                  size="md"
                  variant="textPlain"
                  onClick={action.onClick}
                  disabled={action.disabled}
                  style={{ minWidth: '80px' }}
                  className={action.className}
                >
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      fontSize: vars.typography.fontSize.lg,
                    }}
                  >
                    {action.content}
                  </div>
                </Button>
              );
            }

            return (
              <IconButton
                key={action.id}
                onClick={action.onClick}
                disabled={action.disabled}
                icon={action.content}
                className={action.className}
              />
            );
          })}
        </Group>
      </Paper>
    </Affix>
  );
};
